module.exports = __webpack_public_path__ + "img/Post-2.6be0b71.webp";